export default __webpack_public_path__ + "static/media/wanna4.65ee446e.png";